module.exports = __webpack_public_path__ + "static/media/13-1.f3b59ddf.mp3";